/* eslint-disable */
const translations = {
  en: {
    nav: { home: "Home", jobs: "Find a Job", services: "Services", about: "About", contact: "Contact", hire: "Hire Talent", login: "Sign in", dashboard: "My account", saved: "Saved Jobs", applications: "Applications", profile: "Profile", logout: "Sign out" },
    common: { loading: "Loading...", apply: "Apply now", applyNow: "Apply now", save: "Save", saved: "Saved", remove: "Remove", search: "Search", category: "Category", type: "Job type", location: "Location", clear: "Clear filters", required: "Required", submit: "Submit", cancel: "Cancel", downloadBrochure: "Download Brochure", chatWithUs: "Chat with us", postedOn: "Posted", goBack: "Back", noResults: "No jobs match your filters." },
    hero: {
      eyebrow: "16+ years of staffing excellence",
      title: "Mastering the Art of Workforce Solutions",
      subtitle: "Driven by people. Defined by purpose. ENCES Global places hundreds of vetted candidates every year with leading brands across logistics, manufacturing and administration.",
      ctaBusiness: "I'm a Business",
      ctaWorker: "I'm a Worker",
      trust: "Trusted by Net-A-Porter, Ryder, Hantover, White Toque, ArrowPac",
    },
    mission: {
      eyebrow: "Our mission",
      title: "Driven by people. Defined by purpose.",
      body: "Since 2009 we have helped companies across New Jersey and the Tri-State area scale their workforce with reliable, motivated and properly documented talent. Our team treats every placement as a long-term partnership.",
      stamp: "FOUNDED 2009",
    },
    services: {
      eyebrow: "What we do",
      title: "End-to-end workforce solutions",
      subtitle: "From sourcing the right candidate to running compliant, day-to-day people operations - we own the full lifecycle.",
      viewAll: "Explore all services",
    },
    why: {
      eyebrow: "Why ENCES",
      title: "Why companies choose us",
      bullets: [
        "16+ years of staffing experience in the Tri-State area",
        "Bilingual EN/ES recruiters and account managers",
        "Same-day replacements to keep your operation running",
        "Full HR compliance: I-9, E-Verify, W-4, audit-ready",
        "Weekly billing aligned with your payroll cycle",
        "95% candidate satisfaction across 500+ yearly placements",
      ],
    },
    partners: { eyebrow: "Our partners", title: "Trusted by industry leaders" },
    finalCta: {
      title: "Ready to build your next-best team?",
      subtitle: "Tell us what you need - we'll have qualified candidates ready in under 48 hours.",
      business: "Hire Talent",
      worker: "Browse Jobs",
    },
    footer: {
      tagline: "Mastering the Art of Workforce Solutions",
      address: "505 48th St. Suite 2, Union City, NJ 07087",
      explore: "Explore",
      contact: "Get in touch",
      brochure: "Brochure",
      brochureDesc: "Download our latest staffing capabilities deck",
      rights: "All rights reserved.",
    },
    stats: { years: "Years of experience", placements: "Placements / year", companies: "Companies served", satisfaction: "Candidate satisfaction" },
    jobs: {
      heroTitle: "Find your next job", heroSubtitle: "Hundreds of openings across logistics, manufacturing, administration and more.",
      searchPlaceholder: "Search by title, company, keyword...",
      allCategories: "All categories", allTypes: "All types",
      salary: "Salary range", details: "View details",
    },
    job: { requirements: "Requirements", benefits: "Benefits", description: "Description", apply: "Apply for this role", needSignin: "Please sign in to apply for this position." },
    apply: { title: "Apply for", fullName: "Full name", email: "Email", phone: "Phone", cover: "Cover letter (optional)", success: "Application submitted successfully!", error: "Could not submit application. Please try again." },
    services_page: { title: "Our Services", subtitle: "A complete staffing partner - so you can focus on running your business." },
    contact: {
      title: "Let's talk",
      subtitle: "Reach out to our team. We typically respond within one business day.",
      office: "Our office", team: "Meet the team",
      name: "Your name", email: "Email", phone: "Phone", message: "How can we help?",
      send: "Send message", success: "Message sent! We'll be in touch shortly.", error: "Could not send your message. Please try again.",
    },
    hire: {
      title: "Hire qualified talent in 48 hours",
      subtitle: "Tell us what you need - one of our account managers will get back to you.",
      company: "Company name", contact: "Your name", email: "Work email", phone: "Phone", industry: "Industry", positions: "# of positions",
      message: "Describe the roles you need", submit: "Request talent", success: "Request received! We'll be in touch.",
    },
    about: { title: "Driven by people. Defined by purpose.", subtitle: "ENCES Global has been pairing people and opportunity since 2009.", story: "Born in Union City, NJ, ENCES Global was founded in 2009 with a simple belief: better people make better businesses. Today, we serve 200+ companies across the Tri-State area, placing more than 500 candidates every year with a 95% satisfaction rate." },
    auth: { signIn: "Sign in to continue", google: "Continue with Google", processing: "Signing you in..." },
    dash: {
      saved: "Saved Jobs", noSaved: "You haven't saved any jobs yet.",
      apps: "My Applications", noApps: "You haven't applied to any positions yet.",
      profile: "Profile", language: "Language", english: "English", spanish: "Spanish", save: "Save changes", saved: "Profile updated", logout: "Sign out",
      status: { submitted: "Submitted", review: "Under review", interview: "Interview", offer: "Offer", rejected: "Closed" },
    },
  },
  es: {
    nav: { home: "Inicio", jobs: "Buscar Empleo", services: "Servicios", about: "Nosotros", contact: "Contacto", hire: "Contratar Talento", login: "Iniciar sesión", dashboard: "Mi cuenta", saved: "Empleos Guardados", applications: "Postulaciones", profile: "Perfil", logout: "Cerrar sesión" },
    common: { loading: "Cargando...", apply: "Postular", applyNow: "Postular ahora", save: "Guardar", saved: "Guardado", remove: "Eliminar", search: "Buscar", category: "Categoría", type: "Tipo", location: "Ubicación", clear: "Limpiar filtros", required: "Requerido", submit: "Enviar", cancel: "Cancelar", downloadBrochure: "Descargar Folleto", chatWithUs: "Chatea con nosotros", postedOn: "Publicado", goBack: "Volver", noResults: "Ningún empleo coincide con los filtros." },
    hero: {
      eyebrow: "Más de 16 años de excelencia en staffing",
      title: "Dominando el Arte de las Soluciones de Personal",
      subtitle: "Impulsados por las personas. Definidos por el propósito. ENCES Global coloca cientos de candidatos calificados cada año con marcas líderes en logística, manufactura y administración.",
      ctaBusiness: "Soy Empresa",
      ctaWorker: "Soy Trabajador",
      trust: "Confían en nosotros: Net-A-Porter, Ryder, Hantover, White Toque, ArrowPac",
    },
    mission: {
      eyebrow: "Nuestra misión",
      title: "Impulsados por las personas. Definidos por el propósito.",
      body: "Desde 2009 ayudamos a empresas en New Jersey y la zona Tri-State a escalar su fuerza laboral con talento confiable, motivado y debidamente documentado. Tratamos cada colocación como una alianza de largo plazo.",
      stamp: "FUNDADA EN 2009",
    },
    services: {
      eyebrow: "Lo que hacemos",
      title: "Soluciones integrales de personal",
      subtitle: "Desde encontrar al candidato correcto hasta la gestión diaria del personal con total cumplimiento - cubrimos todo el ciclo.",
      viewAll: "Ver todos los servicios",
    },
    why: {
      eyebrow: "Por qué ENCES",
      title: "Por qué las empresas nos eligen",
      bullets: [
        "Más de 16 años de experiencia en staffing en la zona Tri-State",
        "Reclutadores y account managers bilingües EN/ES",
        "Reemplazos el mismo día para que tu operación no se detenga",
        "Cumplimiento total de RR.HH.: I-9, E-Verify, W-4, listo para auditoría",
        "Facturación semanal alineada a tu nómina",
        "95% de satisfacción de candidatos en 500+ colocaciones anuales",
      ],
    },
    partners: { eyebrow: "Nuestros socios", title: "Confían en nosotros líderes del sector" },
    finalCta: {
      title: "¿Listo para formar tu mejor equipo?",
      subtitle: "Cuéntanos qué necesitas - tendremos candidatos calificados en menos de 48 horas.",
      business: "Contratar Talento",
      worker: "Ver Empleos",
    },
    footer: {
      tagline: "Dominando el Arte de las Soluciones de Personal",
      address: "505 48th St. Suite 2, Union City, NJ 07087",
      explore: "Explorar",
      contact: "Contáctanos",
      brochure: "Folleto",
      brochureDesc: "Descarga nuestra presentación de servicios",
      rights: "Todos los derechos reservados.",
    },
    stats: { years: "Años de experiencia", placements: "Colocaciones / año", companies: "Empresas atendidas", satisfaction: "Satisfacción del candidato" },
    jobs: {
      heroTitle: "Encuentra tu próximo empleo", heroSubtitle: "Cientos de oportunidades en logística, manufactura, administración y más.",
      searchPlaceholder: "Buscar por puesto, empresa, palabra clave...",
      allCategories: "Todas las categorías", allTypes: "Todos los tipos",
      salary: "Rango salarial", details: "Ver detalles",
    },
    job: { requirements: "Requisitos", benefits: "Beneficios", description: "Descripción", apply: "Postular a este puesto", needSignin: "Inicia sesión para postular a este puesto." },
    apply: { title: "Postular a", fullName: "Nombre completo", email: "Correo", phone: "Teléfono", cover: "Carta de presentación (opcional)", success: "¡Postulación enviada con éxito!", error: "No pudimos enviar tu postulación. Intenta de nuevo." },
    services_page: { title: "Nuestros Servicios", subtitle: "Tu socio integral de personal - para que te enfoques en hacer crecer tu negocio." },
    contact: {
      title: "Hablemos",
      subtitle: "Escríbenos. Normalmente respondemos en menos de un día hábil.",
      office: "Nuestra oficina", team: "Conoce al equipo",
      name: "Tu nombre", email: "Correo", phone: "Teléfono", message: "¿Cómo podemos ayudarte?",
      send: "Enviar mensaje", success: "¡Mensaje enviado! Te contactaremos pronto.", error: "No pudimos enviar tu mensaje. Intenta de nuevo.",
    },
    hire: {
      title: "Contrata talento calificado en 48 horas",
      subtitle: "Cuéntanos qué necesitas - un account manager te responderá.",
      company: "Nombre de la empresa", contact: "Tu nombre", email: "Correo corporativo", phone: "Teléfono", industry: "Industria", positions: "# de posiciones",
      message: "Describe los roles que necesitas", submit: "Solicitar talento", success: "¡Solicitud recibida! Te contactaremos.",
    },
    about: { title: "Impulsados por las personas. Definidos por el propósito.", subtitle: "ENCES Global conecta personas con oportunidades desde 2009.", story: "Nacida en Union City, NJ, ENCES Global fue fundada en 2009 con una creencia simple: mejores personas hacen mejores empresas. Hoy atendemos a más de 200 compañías en la zona Tri-State, colocando más de 500 candidatos al año con un 95% de satisfacción." },
    auth: { signIn: "Inicia sesión para continuar", google: "Continuar con Google", processing: "Iniciando sesión..." },
    dash: {
      saved: "Empleos Guardados", noSaved: "Aún no has guardado ningún empleo.",
      apps: "Mis Postulaciones", noApps: "Aún no te has postulado a ninguna posición.",
      profile: "Perfil", language: "Idioma", english: "Inglés", spanish: "Español", save: "Guardar cambios", saved: "Perfil actualizado", logout: "Cerrar sesión",
      status: { submitted: "Enviada", review: "En revisión", interview: "Entrevista", offer: "Oferta", rejected: "Cerrada" },
    },
  },
};

export default translations;
